import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  /** Requests that asked for the loader and haven't finished yet. */
  private pendingLoaderRequests = 0;

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Requests sent with a "loader" header show the full-page loader until
    // they finish. (They used to never hide it themselves: it stayed up until
    // some other request finished, or the 7s safety timer, blocking the page.)
    if (request.headers.has('loader')) {
      // 'loader': 'true' shows the default text; any other value is the
      // message to show ("Loading map layer..."). The header never leaves the app.
      const label = request.headers.get('loader');
      const headers = request.headers.delete('loader');
      this.pendingLoaderRequests++;
      this.loadingService.show(label && label !== 'true' ? label : undefined);
      return next.handle(request.clone({ headers })).pipe(
        finalize(() => {
          this.pendingLoaderRequests = Math.max(0, this.pendingLoaderRequests - 1);
          if (this.pendingLoaderRequests === 0) {
            this.loadingService.hide();
          }
        })
      );
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide();
      })
    );
  }
}
